import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="schedule-entries--cell"
export default class extends Controller {
  static outlets = ["schedule-entries--week-calendar"];
  static WEEKEND_DAYS = [0, 6];

  createEntry(event) {
    if (this.isClickOnExistingEntry(event)) return;

    const { projectPartId, date, effectiveAttendanceRule } = this.extractDataFromEvent(event);

    if (this.isWeekend(date)) {
      this.showWeekendAlert();
      return;
    }

    if (effectiveAttendanceRule) {
      this.navigateToNewEntryForm(projectPartId, date);
    } else {
      alert("区分が未設定です。「勤怠ルール」と「勤怠ルール適用」を設定してください。");
    }
  }

  isClickOnExistingEntry(event) {
    return event.target.closest(".schedule-entry") !== null;
  }

  extractDataFromEvent(event) {
    const { projectPartId, date, effectiveAttendanceRule } = event.currentTarget.dataset;
    return { projectPartId, date, effectiveAttendanceRule };
  }

  isWeekend(dateString) {
    const date = new Date(dateString);
    return this.constructor.WEEKEND_DAYS.includes(date.getDay());
  }

  showWeekendAlert() {
    alert("休日（土日）にはスケジュールを設定できません。");
  }

  navigateToNewEntryForm(projectPartId, date) {
    const url = this.buildNewEntryUrl(projectPartId, date);
    Turbo.visit(url.toString(), { frame: "modal" });
  }

  buildNewEntryUrl(projectPartId, date) {
    const url = new URL("/schedule_entries/new", window.location.origin);
    if (this.scheduleEntriesWeekCalendarOutlet) {
      const weekStart = this.scheduleEntriesWeekCalendarOutlet.getCurrentWeekStart();
      url.searchParams.append("week_start", this.formatDate(weekStart));
    }

    url.searchParams.append("project_part_id", projectPartId);
    url.searchParams.append("date", date);

    return url;
  }

  formatDate(date) {
    return date.toISOString().split('T')[0];
  }
}
